export default "__VITE_ASSET__Dl0ET5CY__"